import { Component, OnInit, Input } from '@angular/core';
import { NgFor } from '@angular/common';

/**
 * Displays the Why Outdoor Access and FAQ Section that is displayed on
 * several onboarding workflow component steps such as:
 *  OfferComponent (Direct Mail Landowner Onboarding)
 *  IntakeFinishComponent (Landowner Onboarding)
 *
*/
interface FAQCopy {
  question: string;
  content: string;
  icon: string;
}
@Component({
    selector: "onboard-faqs",
    templateUrl: "./onboard-faqs.component.html",
    styleUrls: ["./onboard-faqs.component.less"],
    imports: [NgFor]
})
export class OnboardFAQsComponent implements OnInit {
  private readonly _componentName = 'OnboardFAQsComponent';
  public refineEstimateUrl: string = '/#/landowner/refine-estimate';
  faqCards: FAQCopy[];

  constructor() {
  this.faqCards = [
    {question: 'What about insurance?',
      content:'You are a named insured on our complimentary $4M liability and property damage insurance policy.',
      icon: 'fa-solid fa-sharp fa-shield-halved fa-3x faqs-card-icon',
    },
    {question:'What activities are allowed?',
      content:'You decide what is allowed on your property and when. Our members love all sorts of outdoor activities like hunting, fishing, camping & more.',
      icon: 'fa-solid fa-fish fa-3x faqs-card-icon',
    },
    {question:'How much can I make?',
      content:'Use our tool below to estimate your earnings. There are no out-of-pocket costs to you. Outdoor Access takes a small commission on your earnings.',
      icon: 'fa-solid fa-comments-dollar fa-3x faqs-card-icon',
    }
  ]
  }
  
  ngOnInit() {
  }

}
